import {  useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Constants from "../Constants";
import Header from "../components/global/Header";
import LeftNavbar from "../components/global/LeftNavbar";
import Select from 'react-select';
import DataTable from "react-data-table-component";
import {  dateFormat, dateFormatAndStatus } from "../services/Util";
import { getAxiosResponse, postAxiosResponse } from "../services/authApiRoutes/APImethods";
import APIUrls from "../services/APIUrls";
import $ from "jquery";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Breadcrumb } from "../components/dashboard/Breadcrumb";
import DateFormat from "../pages/DateFormat";

export default function Discussion(prop) {

    const scrollRef = useRef(null);
    const { t } = useTranslation();
    const translate = t;
    const navigate = useNavigate();
    const [topics, setTopics] = useState([]);
    const [topicId, setTopicId] = useState([]);
    const [loader, showLoader] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [departments, setDepartments] = useState([]);
    const [tags, setTags] = useState([]);
    const [selectedTopics,setSelectedTopics] = useState([]);
    const [posters, setPosters] = useState([]);
    const [selectedDepartment, updateSelectedDepartment] = useState({label:'All', value:''});
    const[showDetails,toggleShowDetails] = useState(false);
    const statusList = [{label:"All Discussions",value:"all"},{label:translate("project_listing.unread_discussions"),value:"unread"}];
    const followers = [{label:translate("project_listing.all"),value:false},{label:"Followed By Me",value:true}];
    const [refreshPage,setRefreshPage] = useState(false);
    const [selectedPoster,setSelectedPoster] = useState({label:"",value:""});
    const [selectedFollower,setSelectedFollower] = useState({label:"All",value:false});
    const [selectedStatus,setSelectedStatus] = useState({label:"Unread Discussions",value:"unread"});
    const [selectedTag,setSelectedTag] = useState({label:"",value:""});
    const [defaultSortKey,setSortKey] = useState("topic.lastUpdatedTime");
    const [defaultSortOrder,setSortOrder] = useState("DESC");
    const custBootstrapDataRedux = useSelector(
        (store) => store.customer_bootstrap_data
      ).value;
    const paginationRef = useRef();
    const [sortFocus, setsortFocus] = useState('');
	const [toggleCleared, setToggleCleared] = useState(false);

    
    const columns = [
        {
          id: "subject",
          name: "Subject",
          minWidth: "350px",
          sortable: true,
          sortField:"topic.subject",
          cell: (row) => <TitleComponent row={row} />
        },
        {
          id: "entityType",
          name: "Discussion Context",
          minWidth: "350px",
          sortable: true,
          sortField:"topic.project.name",
          cell: (row) => {
            if(row?.entityType === "project"){
                return `${row?.project?.name} (${row.project?.userGroup?.name})`
            }else if(row.entityType === "workspace"){
                return `${row.workspace?.name}`
            }else if(row.projectRequest){
                return `${row?.projectRequest?.name} (${row?.projectRequest?.userGroup?.name})`
            }
          }
        },
        {
          id: "createdDate",
          name: "Date",
          minWidth: "350px",
          sortable: true,
          sortField:"topic.lastUpdatedTime",
          cell: (row) =>
                    row.createdDate !== "" ? (
                      <DateComponent row={row} />
                    ) : ("")
        }
    ];

    const DateComponent = (prop)=>{
        return (
            <>
            <div>
            <DateFormat date={prop.row.createdDate}/>
          </div>
            </>
        )
    };

    useEffect(()=>{
        fetchTopics();
        fetchDepartment();
        fetchTags();
        fetchPosters();
        $('.lastdisable').trigger('focus');
    },[]);

    useEffect(()=>{
        fetchTopics();
    },[refreshPage,selectedDepartment,selectedFollower,selectedPoster,selectedStatus,selectedTag,currentPage,currentPageSize,defaultSortKey,defaultSortOrder]);

    const fetchDepartment = ()=>{
        getAxiosResponse(APIUrls.DEPARTMENT_INCLUDE_SYSTEM_IF_POPULATED)
        .then((response)=>{
            const data = response?.data?.data;
            if(data && data.length > 0) {
                let departments = [{label:translate("project_listing.all"),value:""}];
                data.forEach((dept) => {
                    departments.push({label:dept.name,value:dept.id});
                });
                setDepartments(departments);
            }
        }).catch((err)=>{
            console.error(err);
        })
    };

    const fetchTags = () =>{
        getAxiosResponse(APIUrls.TAGS)
        .then((response)=>{
            let tags = [{label:"Select Tag",value:""}];
            response.data.data.result.forEach((tag)=>{
                tags.push({label:tag.display,value:tag.id});
            });
            setTags(tags);
        }).catch((err)=>{
            console.error(err);
        })
    }

    const fetchTopics=()=>{
        showLoader(true)
        let url = `${APIUrls.TOPIC_PAGED_DATA(selectedStatus.value,defaultSortKey,defaultSortOrder,currentPage)}?tag=${selectedTag.value}&onlyFollowed=${selectedFollower.value}${selectedDepartment?.value !==""?`&deptId=${selectedDepartment?.value}`:""}${selectedPoster?.value !==""?`&postedByUserId=${selectedPoster.value}`:""}&pageSize=${currentPageSize}`;
        getAxiosResponse(url)
        .then((response)=>{
            setTopics(response.data.data.result);
            setTotalRows(response.data.data.resultCount);
            showLoader(false);
            setToggleCleared(false)
            setTimeout(() => {
                if(sortFocus){
                  $(".rdt_TableCol_Sortable[data-column-id='" + sortFocus + "']").trigger('focus');
                  setsortFocus('');
                }
                if (paginationRef.current) {
                      $('#'+ paginationRef.current).trigger('focus');
                      paginationRef.current = '';
                  }
                }, 300);
                showLoader(false)
        })
        .catch((err)=>{
            console.error(err);
            showLoader(false)
        })
    };

    const fetchPosters = ()=>{
        getAxiosResponse(APIUrls.CUSTOMER_TOPIC_POSTER)
        .then((resposne)=>{
            let posters = [{label:translate("project_listing.anyone"),value:""}];
            resposne.data.data.forEach((poster)=>{
                if(poster.organizationType ==="CUSTOMER"){
                    posters.push({label:`${poster.userFirstName} ${poster.userLastName}`,value:poster.userId,type:poster.organizationType});
                }else if(poster.organizationType === "VENDOR"){
                    posters.push({label:`${poster.organizationName}(Vendor)`,value:poster.organizationId,type:poster.organizationType});
                }
            });
            setPosters(posters);
        }).catch((err)=>{
            console.error(err);
        })
    };

    const markasread = ()=>{
        const data = {"ids":selectedTopics};
        postAxiosResponse(APIUrls.TOPIC_MARK_AS_READ,data)
        .then((response)=>{
          if(response.data?.code ===200){
            setSelectedTopics([]);
		    setToggleCleared(true)
            setRefreshPage(refreshPage?false:true);
          }
        }).catch((err)=>{
          console.error(err);
        })
    };

    
    const handleChange = ({ selectedRows })=>{
        const ids = selectedRows?.map(data=>data?.id)
        setSelectedTopics(ids);
    };

    const customSort = (column, sortDirection)=>{
        $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
        .attr({ 'aria-label': column.name, 'aria-sort': sortDirection.toUpperCase() === Constants.DESC  ? Constants.DESCENDING : Constants.ASCENDING });
      setSortKey(column?.sortField)
      setSortOrder(sortDirection?.toUpperCase() )
    };
    $(document).ready(function(){
        $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true");
        $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1"); 
        $(".rdt_Table").attr("aria-label","Discussions"); 
        $('.rdt_Table input').parent().attr("role","cell")
       })

    const getUrl = (topic)=>{
        if(topic.entityType === "project"){
            return `/project/${topic.project.id}/discussions`;
        }else if(topic.entityType === "workspace"){
            return `/campaign/${topic.workspace.id}/discussions`;
        }else if(topic?.projectRequest){
            return  `/project-request/show/${topic?.projectRequest?.id}`;
        }
    };

    const getState = (topic) =>{
        let state = {
            showDetails:true,
            topicId:topic.id
        };
       return({state});
    }


    const handlePageChange = (page) => {
        showLoader(true);
        setCurrentPage(page);
        if ($('#pagination-last-page').attr('aria-disabled')==="true") {
            paginationRef.current = $('#pagination-previous-page').attr('id');
          } else if ($('#pagination-first-page').attr('aria-disabled')==="true") {
            paginationRef.current = $('#pagination-next-page').attr('id');
          } else {
            paginationRef.current = document.activeElement.id;
          }
    };

    const handleRowsPerPageChange = (newPerPage, page) => {
        setCurrentPageSize(newPerPage);
        setCurrentPage(page);
        setTimeout(function(){
            $('.datatable-block nav.rdt_Pagination select').trigger('focus');
          }, 100);
      };

    const TitleComponent = (prop)=>{
        const row = prop.row;
        return (
          <>
            {row?.hasUnreadMessages?
              <div className='inline-flex unread-msg-icon'>
                <svg xmlns="http://www.w3.org/2000/svg" width="17px" height="17px" viewBox="0 0 48 48" fill="none">
                  <rect width="48" height="48" fill="white" fillOpacity="0.01"/>
                  <path d="M44 16V36H29L24 41L19 36H4V6H34" stroke="#1D4ED8" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M23 20H25.0025" stroke="#1D4ED8" strokeWidth="4" strokeLinecap="round"/>
                  <path d="M33.0011 20H35" stroke="#1D4ED8" strokeWidth="4" strokeLinecap="round"/>
                  <path d="M13.001 20H14.9999" stroke="#1D4ED8" strokeWidth="4" strokeLinecap="round"/>
                  <circle cx="43" cy="7" r="3" fill="#1D4ED8"/>
                </svg>
              </div>
            :Constants.BLANK}
            <a tabIndex={0} onClick={()=> navigate(getUrl(row),getState(row))}>{row?.subject?row?.subject:row?.projectRequest?.name}</a>
            {
              row?.hasMessageAttachment || row?.attachment !==""
              ? <span className='attachment-icon' aria-hidden='true'>
                  <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                      <path d="M12.4966 6.0589L11.216 4.85666L4.81261 10.8726C4.56042 11.1097 4.36039 11.3911 4.22394 11.7008C4.08749 12.0105 4.01729 12.3424 4.01735 12.6776C4.01741 13.0128 4.08773 13.3447 4.22428 13.6543C4.36084 13.964 4.56097 14.2454 4.81324 14.4823C5.06551 14.7193 5.36498 14.9073 5.69456 15.0355C6.02413 15.1637 6.37736 15.2297 6.73406 15.2296C7.09077 15.2296 7.44397 15.1635 7.7735 15.0352C8.10303 14.9068 8.40244 14.7188 8.65462 14.4817L16.3387 7.26234C17.1876 6.46441 17.6645 5.38226 17.6644 4.25393C17.6643 3.12561 17.1872 2.04354 16.338 1.24577C15.4889 0.448007 14.3373 -0.000111155 13.1365 2.06817e-08C11.9358 0.000111197 10.7843 0.448443 9.9353 1.24637L1.8677 8.8262L1.85003 8.84162C-0.616678 11.1596 -0.616678 14.9157 1.85003 17.2324C4.31675 19.5492 8.31395 19.5492 10.7807 17.2324L10.7971 17.2158L10.7983 17.217L16.3058 12.0429L15.0252 10.8406L9.51766 16.0136L9.50126 16.029C8.65606 16.8217 7.51072 17.2668 6.31661 17.2668C5.1225 17.2668 3.97716 16.8217 3.13197 16.029C2.71302 15.6345 2.38107 15.1661 2.15514 14.6508C1.92922 14.1354 1.81377 13.5832 1.81541 13.0259C1.81705 12.4685 1.93575 11.9169 2.16471 11.4028C2.39366 10.8886 2.72837 10.422 3.14963 10.0296L3.14837 10.0284L11.2172 2.44861C12.2758 1.45267 13.9994 1.45267 15.0592 2.44861C16.1191 3.44456 16.1178 5.06296 15.0592 6.05772L7.37522 13.2771C7.20325 13.4258 6.97683 13.5062 6.74323 13.5017C6.50963 13.4972 6.28693 13.408 6.12163 13.2528C5.95634 13.0977 5.86124 12.8885 5.85619 12.669C5.85114 12.4495 5.93654 12.2366 6.09454 12.0749L12.4979 6.05772L12.4966 6.0589Z" fill="#1D4ED8"/>
                  </svg>
                </span>
              : Constants.BLANK
            }
            
          </>
        )
    };

    const noDataFoundComponent = () => {
        return (
            <div role="rowgroup">
        <div role="row" className="no-data-display align-center">
          <div role="cell">
            <i className="nodata-icon"></i>
            <p>{Constants.NO_DATA_FOUND}</p>
          </div>
        </div>
      </div>
        );
    }; 
    const crumbs = [
        {label:'Discussions', url:''}
     ];

     $(".rdt_Table").attr("aria-label","Discussions"); 
     $(document).ready(function () {
		$(".rdt_Table .rdt_TableCol span").attr("aria-hidden", "true");
		$(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex", "-1");
	})
  return (
    <>
        <div className="body bg-color">
            <div id="container" className="dashboard-wrapper">
                <Header ref={scrollRef} />
                <LeftNavbar />
                <section className="dashboard-content" ref={scrollRef}>
                    <div id="content" className="dashboard-wrap">
                        <Breadcrumb crumbs={ crumbs } />
                        <div className="user-management-page">
                            <div className="project-heading userprofile-heading">
                                <h3>
                                    {translate("campaign_page.discussions")}
                                    
                                </h3>
                                
                            </div>
                            <div className="white-bg">
                                <div className="flex flex-center justify-end">
                                    {selectedTopics && selectedTopics?.length > 0 && 
                                    <div className="flex two-col">
                                        <button  id="mark-read" className="blue-btn active " onClick={markasread}>
                                        {`${t("mark_as_read")}`}
                                        </button>
                                    </div>}
                                </div>
                                <div className="filter-content flex show-flex">
                                    <div className="filter-inline-list department-dw global-dropdown-block">
                                        <Select className="global-dropdown-select" classNamePrefix='cw'
                                            name="Department" aria-label="Department" placeholder="Department"
                                            options={departments}
                                            onChange={(e)=>updateSelectedDepartment(e)}
                                            value={departments?.filter(data=>data?.value===selectedDepartment?.value) } 
                                        ></Select>
                                    </div>
                                    <div className="filter-inline-list">
                                        <div className="input-group mb-0 global-dropdown-block">
                                            <Select className="global-dropdown-select" classNamePrefix='cw'
                                            name="Following" aria-label="Following" placeholder="Following"
                                            options={followers}
                                            onChange={(e)=>setSelectedFollower(e)}
                                            value={followers?.filter(data=>data?.value===selectedFollower?.value)}
                                            ></Select>
                                        </div>
                                    </div>
                                    <div className="filter-inline-list global-dropdown-block">
                                        <Select className="global-dropdown-select" classNamePrefix='cw'
                                            name="Tags" aria-label="Tags" placeholder="Tags"
                                            options={tags}
                                            onChange={(e)=>setSelectedTag(e)}
                                            
                                        ></Select>
                                    </div>
                                    <div className="filter-inline-list department-dw global-dropdown-block">
                                        <Select className="global-dropdown-select" classNamePrefix='cw'
                                            name="Status" aria-label="Status" placeHolder="Status"
                                            options={statusList}
                                            onChange={(e)=>setSelectedStatus(e)}
                                            value={statusList?.filter(data=>data?.value===selectedStatus?.value)}
                                        ></Select>
                                    </div>
                                    <div className="filter-inline-list global-dropdown-block">
                                        <Select className="global-dropdown-select" classNamePrefix='cw'
                                            name="Postedby" aria-label="Posted By" placeholder="Posted By"
                                            options={posters}
                                            onChange={(e)=>setSelectedPoster(e)}
                                            value={posters.filter(data=>data.value===selectedPoster?.value)}
                                        ></Select>
                                    </div>
                                </div>
                                <div className="global-table datatable-block">
                                    <DataTable columns={columns}
                                        data={topics}
                                        progressPending={loader}
                                        defaultSortFieldId="user.name"
                                        selectableRows
                                        onSelectedRowsChange={handleChange}
                                        sortServer
                                        onSort={customSort}
                                        pagination
                                        paginationServer
                                        onChangeRowsPerPage={handleRowsPerPageChange}
                                        paginationTotalRows={totalRows}
                                        paginationPerPage={10}
                                        paginationRowsPerPageOptions={[10,20,50,100]}
                                        onChangePage={handlePageChange}
                                        noDataComponent={noDataFoundComponent()}
										clearSelectedRows={toggleCleared}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div className="lightbox-panel">
                <div className="inner-lightbox-panel pb-0">
                    <div className="modal-header flex padd-lr">
                        <strong></strong>
                    </div>
                    <div className="lightbox-content padd-22">
                    <p className="f16-para"></p>
                    </div>
                    <div className="modal-footer modal-footer-border flex px-22">
                    <button className="btn btn-bold" >
                        {`${t("button_cancel")}`}
                    </button>
                    <button
                        className="btn btn-bold active"
                       
                    >
                        {`${t("button_accept")}`}
                    </button>
                    </div>
                </div>
            </div>
            
        </div>
    </>
  );
}
